<template>
  <a-modal
    v-model="showModal"
    :footer="null"
    :closable="false"
    :centered="true"
    :class="`infoModal modalContainer tutorialModal`"
    @cancel="null"
  >
    <div class="p-4 text-center">
      <img
        class="rounded-circle mb-3"
        src="../../assets/icons/suggest_circle_icon.svg"
        alt="icon"
      />
      <h4 class="gray700 mb-3 fw700">Other Circle Suggestion</h4>
      <p class="gray500 mb-4 px-4">
        You have selected
        <span class="gray500 fw700">{{ data.selected_type }}</span> as a type of
        {{
          currentCircle.condition_type
            .replace("My", "")
            .replace("Circle", "")
            .replace("my", "")
            .replace("circle", "")
            .trim()
        }}. For a better experience, we suggest you join our
        <span class="gray500 fw700"
          >{{
            data.condition_type
              .replace("My", "")
              .replace("Circle", "")
              .replace("my", "")
              .replace("circle", "")
              .trim()
          }}
          Circle</span
        >
        instead.
      </p>
      <button
        class="rounded w-100 btn btn-one"
        @click="handleOk"
        :style="{ background: getPrimaryColor() }"
      >
        Join
        {{
          data.condition_type
            .replace("My", "")
            .replace("Circle", "")
            .replace("my", "")
            .replace("circle", "")
            .trim()
        }}
        Instead
      </button>
      <button class="rounded w-100 btn btn-two" @click="handleCancel">
        Choose another sub-type
      </button>
    </div>
  </a-modal>
</template>

<script>
import { RepositoryFactory } from "../../repositories/RepositoryFactory";

const CircleRepository = RepositoryFactory.get("circle");

export default {
  data() {
    return {
      showModal: false,
      data: null
    };
  },
  methods: {
    show(data = null) {
      this.data = data;
      this.showModal = true;
    },
    handleOk() {
      CircleRepository.all("", this.data.id)
        .then(res => {
          let circle = res.data.data.all_circles[0];
          this.$store.dispatch("Circle/diseaseTypes", { type: circle.id });
          this.$store.commit("Circle/setCurrentCircle", { data: circle });
          this.$router.push({
            name: "CircleDescription",
            params: {
              circle: this.currentCircle.key_name
            },
            query: {
              circle_id: this.currentCircle.id,
            }
          });
        })
        .catch(err => {
          console.log(err);
        });
    },
    handleCancel() {
      this.showModal = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.ant-modal-content,
.modalContainer {
  width: 400px !important;
}
.btn {
  padding: 12px 24px;
  margin-top: 24px;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
}
.btn-one {
  color: #ffffff !important;
}
.btn-two {
  background: #e2e8f0;
  color: #47556e !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/SuggestCircleForTypeModal.vue